/**
 * @fileoverview Input/output schemas for the chapter-extractor-v2 agent.
 *
 * This agent scans a document to identify chapter structures and key sentences.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';
import { ChapterImportSchema } from '@/domains/chapter-workspace/schemas';

// =============================================================================
// FLOW INPUT SCHEMA
// =============================================================================

export const InputSchema = BaseFlowInputSchema.extend({
  textInput: z.string().describe('The full text content of the document to analyze.'),
}).merge(AGENT_SCHEMA_OBJECTS.storyContext.schema);

export type Input = z.infer<typeof InputSchema>;

// =============================================================================
// OUTPUT SCHEMA
// =============================================================================

export const OutputSchema = z.object({
  chapters: z.array(ChapterImportSchema).describe('An array of all chapters extracted from the document.'),
});

export type Output = z.infer<typeof OutputSchema>;
